<template>
<div class="headerBG">
    <NavBar/>
    <img class="imgFull" src="../../assets/newAssets/vanillamain.png" alt="">
</div>
</template>

<script>
import NavBar from '../Navigation/NavBar.vue'
export default {
    components:{
        NavBar
    }
}
</script>

<style scoped>

.imgFull
{
    width: 100%;
    margin-top: -20vh;
}

</style>


// WEBPACK FOOTER //
// src/components/Desktop/Header.vue